/**
 * Maximum size for a certificate PDF.
 *
 * Certificates cannot be compressed client-side the way images can, so this
 * limit is the only lever. 5MB used to reject the common phone flow —
 * photographing a paper certificate and exporting it to PDF lands at 3-8MB,
 * and multi-page scans go well past that.
 *
 * The `volunteer-certificates` bucket itself accepts roughly 50MB (measured:
 * 25MB uploads fine, 60MB returns 413). We deliberately stay far below that:
 * certificates are rendered with pdf.js on phones, uploads have no progress
 * indicator, and keeping headroom means an oversized file gets this clear
 * message rather than an opaque 413 from storage.
 */
export const MAX_CERTIFICATE_BYTES = 15 * 1024 * 1024;

/** Human-readable form of {@link MAX_CERTIFICATE_BYTES}, for error copy. */
export const MAX_CERTIFICATE_LABEL = '15MB';
